// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var EntitySettingsController = function ($scope, $routeParams, $modal, $http, Entity, EntitySettings, Settings) {

    $scope.defaultFeaturePlaceHolder = 'Select feature';
    $scope.defaultDisablingActionsPlaceHolder = 'Select action to disable';
    $scope.DeleteWithinDBTransaction = true;

    const ssoFeatures = Object.freeze({
        "AzureActiveDirectory": "AzureActiveDirectory",
        "OpenIdConnect": "OpenIdConnect"
    });

    const legalEntityFeatures = Object.freeze({
        "SalesEntities": "SalesEntities",
        "TenantHierarchy": "TenantHierarchy"
    });
    
    const writeOffIncompatibleEntityFeatures = Object.freeze({
        "RevenueWriteOff": "RevenueWriteOff",
        "Pons": "Pons"
    });

    var excludeSubArrayFromArray = function(array, subArray) {
        var filteredArray = [];
        for (var i = 0; i < array.length; i++) {
            if (!subArray.includes(array[i])) {
                filteredArray.push(array[i]);
            }
        }

        return filteredArray;
    };
    $scope.isChildEntity = false;
    var allAvailableFeaturesSource = [];
    let allAvailableForDisablingActionsSource = [];
    
    function updateAvailableFeatures () {
        $scope.allAvailableFeatures = excludeSubArrayFromArray(allAvailableFeaturesSource, $scope.entityFeatures);
    }

    function updateAvailableForDisablingActions () {
        $scope.allAvailableForDisablingActions = excludeSubArrayFromArray(allAvailableForDisablingActionsSource, $scope.disabledActions);
    }

    Entity.get({ entityId: $routeParams.entityId }, function (data) {
        let i;
        $scope.entity = data.Entity;
        $scope.entityFeatures = data.Features;
        $scope.disabledActions = data.DisabledActions;
        $scope.status = data.Entity.Status;

        if ($scope.entity.ParentId) {
            $scope.isChildEntity = true;
        }
        
        allAvailableFeaturesSource.push($scope.defaultFeaturePlaceHolder);
        for (i = 0; i < data.AllAvailableFeatures.length; i++) {
            allAvailableFeaturesSource.push(data.AllAvailableFeatures[i]);
        }

        allAvailableForDisablingActionsSource.push($scope.defaultDisablingActionsPlaceHolder);
        for (i = 0; i < data.AllAvailableForDisablingActions.length; i++) {
            allAvailableForDisablingActionsSource.push(data.AllAvailableForDisablingActions[i]);
        }
        
        updateAvailableFeatures();
        updateAvailableForDisablingActions();
    });

    $scope.newFeature = $scope.defaultFeaturePlaceHolder;
    $scope.newDisabledAction = $scope.defaultDisablingActionsPlaceHolder;
    $scope.settings = EntitySettings.get({entityId: $routeParams.entityId});
    if ($scope.inRoleSuperAdmin()) {
        $scope.appSettings = Settings.get();
        Settings.get({}, function (data) {
            $scope.legalEntityDeletionEnabled = data.SimulationEnabled
        });
    } else {
        $scope.legalEntityDeletionEnabled = false;
    }

    $scope.deleteDomain = function (domain) {
        var index = $scope.settings.OwnSenderEmailAddressDomains.indexOf(domain);
        if (index > -1) {
            $scope.settings.OwnSenderEmailAddressDomains.splice(index, 1);
        }
    };
    
    $scope.addDomain = function (newDomain) {
        if ( newDomain ) {
            if ( $scope.settings.OwnSenderEmailAddressDomains ) {
                $scope.settings.OwnSenderEmailAddressDomains.push( newDomain );
            } else {
                $scope.settings.OwnSenderEmailAddressDomains = [newDomain];
            }
            $scope.newDomain = '';
        }
    };

    $scope.deleteNetwork=function(networkId)
    {
        var index = $scope.settings.EInvoicingNetworks.map(x => x.NetworkId).indexOf(networkId);
        if (index > -1) {
            $scope.settings.EInvoicingNetworks.splice(index, 1);
        }
    };

    $scope.addNetwork = function (networkName, networkId) {
        if ( networkName &&  networkId) {

            var newNetwork = {"NetworkName": networkName, "NetworkId": networkId};

            if ( $scope.settings.EInvoicingNetworks ) {
                if($scope.settings.EInvoicingNetworks.some(x => x.NetworkId === networkId)){
                    alert('Network ID already exists.');
                    return;
                }
                $scope.settings.EInvoicingNetworks.push(newNetwork);
            } else {
                $scope.settings.EInvoicingNetworks = [newNetwork];
            }
            $scope.newNetworkName = '';
            $scope.newNetworkId = '';
        }
    };

    function saveSettings() {
        EntitySettings.update({ entityId: $routeParams.entityId }, $scope.settings, function () {
            $scope.notify("success", "saved successfully");
        });
    }
    
    $scope.saveSettings = function () {
        $scope.confirm('Save settings', 'Are you sure you want to save new settings?', saveSettings)
    };
    
    var openConfirmationDialog = function (title, description, delete_all) {
        var modalInstance = $modal.open({
            templateUrl: 'confirm-entity-delete-dialog.html',
            controller: ModalConfirmDeleteEntityCtrl,
            windowClass: "fade in",
            resolve: {
                id: function () { return $routeParams.entityId; },
                title: function () { return title; },
                description: function () { return description; },
                delete_all: function () { return delete_all; },
                isInTransaction: function () { return $scope.DeleteWithinDBTransaction; },
            }
        });
    };
    
    $scope.requestDeleteEntity = function () {
        openConfirmationDialog("Legal Entity Deletion", "CAUTION! Do you really want to remove ALL DATA of this entity?", true);
    };
    
    $scope.requestCleanupEntity = function () {
        openConfirmationDialog("Legal Entity Customer Deletion", "CAUTION! This will remove the entity's customers and related data. Do you really want to delete?", false);
    };

    function updateStatus() {
        $scope.entity.Status = $scope.status;
        $http({
            method: "PATCH",
            url: baseUrl + "api/v1/Entities/" + $routeParams.entityId,
            data: $scope.entity
        },
        function (data) {
        },
        restoreStatus);
    }

    function restoreStatus() {
        $scope.status = $scope.entity.Status;
    }
    
    $scope.setStatus = function () {
        $scope.confirm("Status", "CAUTION! Changing the status is dangerous and will change the behaviour of the account. Are you sure you want to go on?",
            updateStatus, restoreStatus);
    };
    
    $scope.addFeature = function (feature) {
        if ($scope.entityFeatures.indexOf(feature) >= 0 || feature === $scope.defaultFeaturePlaceHolder)
            return;

        if ($scope.isInconsistentByEntityFeature(feature)) {
            window.alert("SalesEntities and TenantHierarchy features cannot be activated at the same time");
            return;
        }
        
        if ($scope.isInconsistentByWriteOffPonsFeature(feature)) {
            window.alert("RevenueWriteOff and Pons features cannot be activated at the same time");
            return;
        }

        if ($scope.isInconsistentBySSOFeature(feature)) {
            window.alert("AzureActiveDirectory and OpenIdConnect features cannot be activated at the same time");
            return;
        }

        $scope.entityFeatures.push(feature);
        $scope.newFeature = $scope.defaultFeaturePlaceHolder;
        updateAvailableFeatures();
    };

    $scope.addDisabledAction = function (action) {
        if ($scope.disabledActions.indexOf(action) >= 0 || action === $scope.defaultDisablingActionsPlaceHolder)
            return;

        $scope.disabledActions.push(action);
        $scope.newDisabledAction = $scope.defaultDisablingActionsPlaceHolder;
        updateAvailableForDisablingActions();
    };

    $scope.isInconsistentByEntityFeature = function (feature) {
        return ((feature === legalEntityFeatures.SalesEntities &&
                $scope.entityFeatures.indexOf(legalEntityFeatures.TenantHierarchy) >= 0) ||
            (feature === legalEntityFeatures.TenantHierarchy &&
                $scope.entityFeatures.indexOf(legalEntityFeatures.SalesEntities) >= 0));
    }
    
    $scope.isInconsistentByWriteOffPonsFeature = function (feature) {
        return ((feature === writeOffIncompatibleEntityFeatures.RevenueWriteOff &&
                $scope.entityFeatures.indexOf(writeOffIncompatibleEntityFeatures.Pons) >= 0) ||
            (feature === writeOffIncompatibleEntityFeatures.Pons &&
                $scope.entityFeatures.indexOf(writeOffIncompatibleEntityFeatures.RevenueWriteOff) >= 0));
    }

    $scope.isInconsistentBySSOFeature = function (feature) {
        return ((feature === ssoFeatures.OpenIdConnect &&
                $scope.entityFeatures.indexOf(ssoFeatures.AzureActiveDirectory) >= 0) ||
            (feature === ssoFeatures.AzureActiveDirectory &&
                $scope.entityFeatures.indexOf(ssoFeatures.OpenIdConnect) >= 0));
    }
    
    $scope.removeFeature = function (feature) {
        $scope.entityFeatures.remove(feature);
        updateAvailableFeatures();
    };

    $scope.removeActionFromTheDisabledList = function (action) {
        $scope.disabledActions.remove(action);
        updateAvailableForDisablingActions();
    };

    $scope.saveProperties = function () {
        $http({
            method: "PATCH",
            url: baseUrl + "api/v1/Entities/" + $routeParams.entityId,
            data: { Features: $scope.entityFeatures, Key: $scope.entity.Key, DisabledActions: $scope.disabledActions },
        }).then(function() {
            $scope.notify("success", "saved successfully");
        });
    };
};
EntitySettingsController.$inject = ['$scope', '$routeParams', '$modal', '$http', 'Entity', 'EntitySettings', 'Settings'];
